module.exports = __webpack_public_path__ + "img/birthday-pic1.ffd7784b.png";